import { Button } from '../../../form/buttons/button/component/Button';
import { DialogModal } from '../../dialog/components/DialogModal';
import { ModalBody } from '../../dialog/components/ModalBody';
import { ModalButtons } from '../../dialog/components/ModalButtons';
import { ModalTitle } from '../../dialog/components/ModalTitle';

export interface ConfirmProps {
  cancelLabel?: string;
  confirmLabel?: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export const Confirm = ({
  cancelLabel = 'Cancel',
  confirmLabel = 'Ok',
  message,
  onCancel,
  onConfirm,
  title,
}: ConfirmProps) => {
  return (
    <DialogModal>
      <ModalTitle onClose={onCancel}>{title}</ModalTitle>
      <ModalBody>{message}</ModalBody>
      <ModalButtons>
        <Button use="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button use="primary" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ModalButtons>
    </DialogModal>
  );
};
